module.exports = __webpack_public_path__ + "static/media/logoGreen.0c979f85.png";